import script from "./sider.vue?vue&type=script&setup=true&lang=js"
export * from "./sider.vue?vue&type=script&setup=true&lang=js"

import "./sider.vue?vue&type=style&index=0&id=6d6b7f2b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d6b7f2b"]])

export default __exports__